import React from "react";
import { motion } from "framer-motion";
import "./About.css";
import { motion as MotionDiv } from "framer-motion";
import FloatingDots from "./FloatingDots";
import plus from "../assets/plus.png";
import aboutgraphics from "../assets/Home-about.png";
import leftShape from "../assets/float-left.png";
import { FaArrowRight, FaCog } from "react-icons/fa";
import { FaShieldAlt, FaCheckCircle, FaClock, FaUser, FaLightbulb } from "react-icons/fa"

const About = () => {
  const isMobile = window.innerWidth <= 768; // detect mobile

  // If mobile → just use div (no animation), else → motion.div
  const MotionDiv = isMobile ? "div" : motion.div;

  return (
    <section id="about" className="about">
      {/* Decorative left-side shape */}
      <div className="about-left-shape">
        <img src={leftShape} alt="Decorative Shape" />
      </div>
      <div className="about-container">
        {/* LEFT SIDE with decorative images */}
        <MotionDiv
  className="about-left"
  {...(!isMobile && {
    initial: { opacity: 0, x: -80 },
    whileInView: { opacity: 1, x: 0 },
    transition: { duration: 1 },
  })}
>
  <img src={plus} alt="43+ Years" className="years-badge" />

  <div className="about-graphics">
    <img
      src={aboutgraphics}
      alt="Industrial Graphics"
      className="main-graphic"
    />

 <FloatingDots />
  </div>
</MotionDiv>

        {/* RIGHT SIDE content */}
        <MotionDiv
          className="about-right"
          {...(!isMobile && {
            initial: { opacity: 0, x: 80 },
            whileInView: { opacity: 1, x: 0 },
            transition: { duration: 1 },
          })}
        >
          <span className="about-label">
            <FaCog style={{ marginRight: "8px", color: "#0077b6" }} />
            About Us
          </span>

          <h3>
            Welcome to Sreenathji Enterprises –{" "}
            <span className="highlight">
              A Legacy in Industrial Distribution
            </span>
          </h3>
          <p>
            Sreenathji Enterprises (SE) was established in 1982 with a humble vision — to
serve the industrial sector with quality products and reliable service. Over the
decades, what began as a modest venture has grown into one of the leading
distribution houses in Karnataka and Hosur region, trusted by industries across
the country.</p> <p>Over the years, we’ve built strong associations as authorized distributors for toptier multinational companies in Specialty chemicals, Abrasives, Wood
coatings, Corrosion resistant paints, Cutting tools, Basic chemicals and
Cutting inserts. Our strong partnerships and dedication allow us to deliver premium
solutions that meet the evolving demands of our customers. In addition, Sreenathji
Enterprises is also an importer of high-grade metals like Nickel, Zinc, Tin and
Copper from across the globe.
          </p>


         <button
  className="learn-btn"
  onClick={() => (window.location.href = "/about")}
>
  <span className="btn-text">Learn More</span>
  <span className="btn-icon">
    <FaArrowRight />
  </span>
</button>

        </MotionDiv>

        <div className="about-bottom-right">
          <img src={require("../assets/iso.png")} alt="Decorative Small" />
        </div>
      </div>
<div className="values-section">
  <div className="values-grid">
    <div className="value-card">
      <div className="value-icon"><FaShieldAlt /></div>
      <h3>Trust</h3>
      <p>The foundation of our success</p>
    </div>

    <div className="value-card">
      <div className="value-icon"><FaCheckCircle /></div>
      <h3>Quality</h3>
      <p>Every material meets global standards</p>
    </div>

    <div className="value-card">
      <div className="value-icon"><FaClock /></div>
      <h3>Reliability</h3>
      <p>On-time delivery, every time</p>
    </div>

    <div className="value-card">
      <div className="value-icon"><FaUser /></div>
      <h3>Personal Attention</h3>
      <p>One-on-one customer care</p>
    </div>

    <div className="value-card">
      <div className="value-icon"><FaLightbulb /></div>
      <h3>Guidance</h3>
      <p>Beyond products, we provide advice & assurance</p>
    </div>
  </div>
</div>

    </section>
  );
};

export default About;
